import { useQuery } from "@apollo/client";

import { ProjectReviewVisitV2ObservationList_GetDataDocument } from "../queries.generated";

export function useProjectReviewVisitV2ObservationList_GetData(
    visitId: string,
    pageSize: number,
    page: number,
    layerId?: string,
) {
    const { data, loading, error, previousData } = useQuery(ProjectReviewVisitV2ObservationList_GetDataDocument, {
        variables: {
            visitId,
            params: {
                pageSize,
                page,
                layerId,
            },
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
    });

    const result = loading ? previousData : data;
    const observations = result?.observationsByVisitGetAll.data;

    return {
        observations,
        hasAllObservationsApproved: result?.plannerVisitHasAllObservationsApproved,
        queryInfo: result?.observationsByVisitGetAll.queryInfo,
        loading,
        error,
    };
}
